import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { Calendar, MessageSquare, X } from "lucide-react";

function AddAcknowledgeExpiryDatePopup({ closePopup, confirm }) {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [noExpiryDate, setNoExpiryDate] = useState(false);
    const [comment, setComment] = useState("");
    const [valid, setValid] = useState(false);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    const onClick = () => {
        closePopup();
        confirm(selectedDate, comment);
    };

    const onExpiryNoDateChange = (value) => {
        setNoExpiryDate(value);
        if (value) {
            setSelectedDate(null);
        } else {
            setSelectedDate(new Date());
        }
    };

    const handleCommentChange = (value) => {
        setComment(value);
        setValid(!!value && value.length >= 1);
    };

    return (
        <div className="oct-shared-popup oct-shared-popup--acknowledge" role="dialog" aria-modal="true" aria-labelledby="oct-expiry-popup-title">
            <div className="oct-shared-popup__backdrop" onClick={closePopup} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap oct-shared-popup__title-wrap--plain oct-shared-popup__title-wrap--acknowledge">
                        <div className="oct-shared-popup__title-icon oct-shared-popup__title-icon--acknowledge">
                            <Calendar size={18} />
                        </div>
                        <h4 id="oct-expiry-popup-title" className="oct-shared-popup__title">Add Expiry Date</h4>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={closePopup} aria-label="Close popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <label className="oct-shared-popup__checkbox-row oct-shared-popup__checkbox-row--acknowledge">
                        <input
                            type="checkbox"
                            checked={!!noExpiryDate}
                            onChange={() => onExpiryNoDateChange(!noExpiryDate)}
                        />
                        <span>No Expiry Date</span>
                    </label>

                    {!noExpiryDate && (
                        <div className="oct-shared-popup__field oct-shared-popup__field--acknowledge-calendar">
                            <label className="oct-shared-popup__label oct-shared-popup__label--with-icon" htmlFor="oct-acknowledge-datepicker">
                                <span className="oct-shared-popup__field-icon oct-shared-popup__field-icon--acknowledge" aria-hidden="true">
                                    <Calendar size={16} />
                                </span>
                                Expiry Date
                            </label>
                            <div className="oct-shared-popup__datepicker-wrap oct-shared-popup__datepicker-wrap--acknowledge" id="oct-acknowledge-datepicker">
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                minDate={new Date()}
                                calendarClassName="oct-acknowledge-datepicker"
                                inline
                            />
                            </div>
                        </div>
                    )}

                    <div className="oct-shared-popup__field oct-shared-popup__field--acknowledge-comment">
                        <label className="oct-shared-popup__label oct-shared-popup__label--with-icon" htmlFor="expiry-comment">
                            <span className="oct-shared-popup__field-icon oct-shared-popup__field-icon--acknowledge" aria-hidden="true">
                                <MessageSquare size={16} />
                            </span>
                            Comment <span className="oct-shared-popup__required-mark">*</span>
                        </label>
                        <textarea
                            id="expiry-comment"
                            className={`oct-shared-popup__textarea ${valid ? "" : "is-invalid"}`}
                            rows={4}
                            value={comment}
                            onChange={(event) => handleCommentChange(event.target.value)}
                            placeholder="Add your comment here..."
                        />
                    </div>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={closePopup}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        onClick={onClick}
                        disabled={!valid}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    };
}

export default connect(mapStateToProps)(AddAcknowledgeExpiryDatePopup);
